import { BsDatabase } from "react-icons/bs";
import { Dataset } from "./api/Application";

export function DatasetItem( { dataset, onClick, isSelected }: {
    dataset: Dataset,
    onClick: () => void,
    isSelected: boolean;
} ) {
    const selStyle = "border border-primary";
    const baseStyle = "match-item mx-2 my-1 mb-1 p-3 rounded-4 d-flex align-items-center border-1 shadow";
    const style = `${isSelected ? selStyle : ""} ${baseStyle}`;

    return (
        <div className={style}
            style={{ cursor: 'pointer' }}
            onClick={onClick}>
            <div className="mx-3 d-flex flex-column flex-shrink-0 align-items-center justify-content-center">
                <BsDatabase className="text-primary" style={{ fontSize: '40px' }} />
            </div>
            <div className="d-flex flex-column gap-1 p-2">
                <div className="fw-bold">
                    {dataset.name}
                </div>
                <div className="text-muted small">
                    {dataset.description || 'No description'}
                </div>
            </div>
        </div>
    );
}
